export default {
  SET_VISIBLE: 'set_visible',
  SET_SPEAKER: 'set_speaker',
  SEND_MESSAGE: 'send_message',
  PLAYER_MOVE: 'player-move',
  ACT_1_ENDING: 'act-1-ending',
  ACT_2: 'act-2',
  ACT_2_ENDING: 'act-2-ending',
  ACT_3: 'act-3',
  ACT_3_ENDING: 'act-3-ending',
  ACT_4: 'act-4',
  FIRST_DOOR_ENCOUNTER: 'first-door-encounter',
  FIRST_DOOR_CLOSE: 'first-door-close',
  SECOND_DOOR_ENCOUNTER: 'second-door-encounter',
  THIRD_DOOR_ENCOUNTER: 'third-door-encounter',
  REVEAL_FACE: 'reveal-face',
};
